<template>
  <div class="app-vue-container">
    <router-view />
  </div>
</template>

<style>
body {
  padding: 0;
  margin: 0;
}
body * {
  padding: 0;
  margin: 0;
  /* Note: Font レトロチック */
  font-family: Comic Sans MS;
  font-weight: 500;
  -webkit-font-smoothing: none;
}
a:hover{
  color: rgb(207, 112, 255);
}
p {
  font-weight: 400;
}

/* #nav a {
  font-weight: bold;
  color: #2c3e50;
}
#nav a.router-link-exact-active {
  color: #42b983;
} */
</style>
